(function() {
	'use strict';

	angular.module('etrrbApp').controller('ETrrbController', ETrrbController);

	ETrrbController.$inject = [ '$scope', '$window', 'ETrrbService', '$log',
			'AlertService', 'NgTableParams', '$state', 'ETRRB_STATUS',
			'authExpiredInterceptor', '$base64', 'CommonService', 'FORMAT_DATE', '$uibModal', 'ETRRB_STATUS_SYNC','ETRRB_BOOKLET_TYPE', 'ETRRB_PAY_METHOD', '$filter', 'ETRRB_TXN_TYPE'];

	function ETrrbController($scope, $window, ETrrbService, $log, AlertService,
			NgTableParams, $state, ETRRB_STATUS, authExpiredInterceptor, $base64,
			CommonService, FORMAT_DATE, $uibModal, ETRRB_STATUS_SYNC, ETRRB_BOOKLET_TYPE, ETRRB_PAY_METHOD, $filter, ETRRB_TXN_TYPE) {
		var etrrbCtr = this;
		var self = $scope;
		etrrbCtr.ETRRB_STATUS = ETRRB_STATUS;
		etrrbCtr.ETRRB_STATUS_SYNC = ETRRB_STATUS_SYNC;
		etrrbCtr.ETRRB_BOOKLET_TYPE = ETRRB_BOOKLET_TYPE;
		etrrbCtr.ETRRB_TXN_TYPE = ETRRB_TXN_TYPE;
		etrrbCtr.ETRRB_PAY_METHOD = ETRRB_PAY_METHOD;
		self.loading = false;
		etrrbCtr.txnType = '100';
		etrrbCtr.findReceiptByBookletNum = findReceiptByBookletNum;
		etrrbCtr.findReceiptCancelByBookletNum = findReceiptCancelByBookletNum;
		etrrbCtr.findAgentSmsRemind = findAgentSmsRemind;
		etrrbCtr.updateAgentSmsRemind = updateAgentSmsRemind;
		etrrbCtr.receiptTypes = CommonService.query({
			masterurl : 'receipt-types'
		}, function(result) {
			self.receiptTypes = result;
		});
		function findReceiptByBookletNum() {
			etrrbCtr.tableParams = new NgTableParams(
					{
						page : 1,
						count : 20,
					},
					{
						total : 0,
						counts : [ 20, 40, 80 ],
						defaultSort : 'desc',
						getData : function(params) {
							var param = {};
							param['page'] = params.page();
							param['size'] = params.count();
							param['uri'] = 'get-etrrb-by-booklet-num';
							if (etrrbCtr.bookletNum) {
								param['bookletNum'] = etrrbCtr.bookletNum;
							}
							if (etrrbCtr.proposalPolicyNum) {
								param['proposalPolicyNum'] = etrrbCtr.proposalPolicyNum;
							}
							if (etrrbCtr.agentCode) {
								param['agentCode'] = etrrbCtr.agentCode;
							}
							if (etrrbCtr.receiptTypeCode) {
								param['receiptTypeCode'] = etrrbCtr.receiptTypeCode;
							}
							if (etrrbCtr.txnStatus) {
								param['txnStatus'] = etrrbCtr.txnStatus;
							}
							if (etrrbCtr.txnType) {
								param['txnType'] = etrrbCtr.txnType;
							}
							if (etrrbCtr.fromDate) {
			        			param['fromDate'] = $filter('date')(etrrbCtr.fromDate, FORMAT_DATE);
			        		}
							if (etrrbCtr.fromDate) {
			        			param['toDate'] = $filter('date')(etrrbCtr.toDate, FORMAT_DATE);
			        		}
							return ETrrbService.get(param).$promise
									.then(function(result) {
										if (result != null
												&& (result.totalElements == undefined || result.totalElements == 0))
											self
													.addAlert(
															'Không tìm thấy phiếu thu.',
															'warning');
										params.total(result.totalElements);
										return result.content;
									});
						}
					});
		}
		;
		
		function findReceiptCancelByBookletNum() {
			etrrbCtr.tableParams = new NgTableParams(
					{
						page : 1,
						count : 20,
					},
					{
						total : 0,
						counts : [ 20, 40, 80 ],
						defaultSort : 'desc',
						getData : function(params) {
							var param = {};
							param['page'] = params.page();
							param['size'] = params.count();
							param['uri'] = 'get-etrrb-cancel';
							if (etrrbCtr.bookletNum) {
								param['bookletNum'] = etrrbCtr.bookletNum;
							}
							if (etrrbCtr.proposalPolicyNum) {
								param['proposalPolicyNum'] = etrrbCtr.proposalPolicyNum;
							}
							if (etrrbCtr.agentCode) {
								param['agentCode'] = etrrbCtr.agentCode;
							}
							if (etrrbCtr.receiptTypeCode) {
								param['receiptTypeCode'] = etrrbCtr.receiptTypeCode;
							}
							if (etrrbCtr.txnStatus) {
								param['txnStatus'] = etrrbCtr.txnStatus;
							}
							if (etrrbCtr.txnType) {
								param['txnType'] = etrrbCtr.txnType;
							}
							if (etrrbCtr.fromDate) {
			        			param['fromDate'] = $filter('date')(etrrbCtr.fromDate, FORMAT_DATE);
			        		}
							if (etrrbCtr.fromDate) {
			        			param['toDate'] = $filter('date')(etrrbCtr.toDate, FORMAT_DATE);
			        		}
							return ETrrbService.get(param).$promise
									.then(function(result) {
										if (result != null
												&& (result.totalElements == undefined || result.totalElements == 0))
											self
													.addAlert(
															'Không tìm thấy phiếu thu.',
															'warning');
										params.total(result.totalElements);
										return result.content;
									});
						}
					});
		}
		;

		function findAgentSmsRemind() {
			etrrbCtr.tableParams = new NgTableParams(
					{
						page : 1,
						count : 20,
					},
					{
						total : 0,
						counts : [ 20, 40, 80 ],
						defaultSort : 'desc',
						getData : function(params) {
							var param = {};
							param['page'] = params.page();
							param['size'] = params.count();
							param['uri'] = 'find-agent-sms-remind';
							if (etrrbCtr.bookletNum) {
								param['bookletNum'] = etrrbCtr.bookletNum;
							}
							if (etrrbCtr.proposalPolicyNum) {
								param['proposalPolicyNum'] = etrrbCtr.proposalPolicyNum;
							}
							if (etrrbCtr.agentCode) {
								param['agentCode'] = etrrbCtr.agentCode;
							}
							if (etrrbCtr.agentName) {
								param['agentName'] = etrrbCtr.agentName;
							}
							if (etrrbCtr.bookletType) {
								param['bookletType'] = etrrbCtr.bookletType;
							}
							if (etrrbCtr.fromDate) {
			        			param['fromDate'] = $filter('date')(etrrbCtr.fromDate, FORMAT_DATE);
			        		}
							if (etrrbCtr.fromDate) {
			        			param['toDate'] = $filter('date')(etrrbCtr.toDate, FORMAT_DATE);
			        		}
							return ETrrbService.get(param).$promise
									.then(function(result) {
										if (result != null
												&& (result.totalElements == undefined || result.totalElements == 0))
											self
													.addAlert(
															'Không tìm thấy phiếu thu.',
															'warning');
										params.total(result.totalElements);
										return result.content;
									});
						}
					});
		};
		
		function updateAgentSmsRemind(item) {
			$scope.loading = true;
			ETrrbService.updateAgentSmsRemind({
				uri : 'update-agent-sms-remind',
				agentSmsRemindId: item.agentSmsRemindId,
				statusRemind: item.statusRemind,
				agentCode: item.agentCode,
				agentName: item.agentName
			}, function(result) {
				if(result.response != '') {
					item.statusRemind = result.response;
					if(result.response == '3'){
						$scope.addAlert('Hủy vi phạm chậm nộp phí cho TVV [' + item.agentCode + ' - ' + item.agentName + '] thành công','success');
					}
					else{
						$scope.addAlert('Cập nhật vi phạm chậm nộp phí cho TVV [' + item.agentCode + ' - ' + item.agentName + '] thành công','success');
					}
				}else {
					$scope.addAlert('Lỗi hệ thống. Vui lòng xử lý lại','danger');
				}
				$scope.loading = false;
			}, function(error) {
				$scope.addAlert('Lỗi hệ thống. Vui lòng xử lý lại','danger');
				$scope.loading = false;
			});
		}
		etrrbCtr.openReceipt = function(item) {
			self.loading = true;
			ETrrbService.get({
				uri : 'check-etrrb-is-not-txn-new',
				eTrrbReceiptId : item.etrrbReceiptId
			}, function(result) {
				self.loading = false;
				var uri = 'ga/receipt/#/';
				var num = $base64.encode(item.etrrbReceiptId);
				if (result.policyNum != null && result.policyNum != ''
						&& result.policyNum != undefined) {
					uri = uri.concat('policy///');
				} else {
					uri = uri.concat('individual///');
				}
				uri = uri.concat(num);
				$window.open(GLOBAL_URL + uri, '_blank')
			}, function(error) {
				self.loading = false;
			});
		}
		
		etrrbCtr.openReceiptSync = function(item) {
			self.loading = true;
			ETrrbService.get({
				uri : 'sync-booklet-status',
				txnId : item.txnId
			}, function(result) {
				self.loading = false;
				if(result != null && result.txnStatus != null)
					item.txnStatus = result.txnStatus;
			}, function(error) {
				self.loading = false;
			});
		}
		
		etrrbCtr.viewReceipt = function(bookletNum,txnType) {
			self.loading = true;
			if(bookletNum != undefined && bookletNum != ''){
				self.loading = false;
				ETrrbService.returnValue({
					uri : 'get-filenet-id',
					bookletNum: bookletNum,
					txnType: txnType
				}, function(result) {
					if(result.response != undefined && result.response != ''){
						self.addAlert('Tìm thấy hóa đơn của phiếu thu điện tử.' + result.response,'info');
						$window.open(GLOBAL_URL + 'api/file-net/download-on-file-net/'+ result.response+'?access_token=' + authExpiredInterceptor.getToken());    
					}else {
						self.addAlert('Không tìm thấy hóa đơn của phiếu thu điện tử trên File Net.','warning');
					}
					self.loading = false;
				}, function(error) {
					self.loading = false;
				});
				
			}else {
				self.loading = false;
				self.addAlert('Không tìm thấy hóa đơn của phiếu thu điện tử.','warning');
			}
		}
		
		etrrbCtr.openDialogConfirm = function(bookletNum) {
    		self.clearMessage();
    		if(bookletNum != undefined && bookletNum != ''){
    			var modalInstance = 
					//show dialog
					$uibModal.open({
						animation : true,
						templateUrl : GLOBAL_URL+ 'partial?uri=ga/etrrb/etrrb-cancel-dialog',
						controller : 'EtrrbCancelDialogController as etrrbCancelDialogCtr',
						size : 'lg',
						resolve : {
							bookletNum: function(){
								return bookletNum;
							}
						}
				});
    			modalInstance.result.then(
						function(result) {
							findReceiptCancelByBookletNum();
						},
						function(error) {
							
						});
    		}
    	}
		
		etrrbCtr.openRequestDialogConfirm = function(item, isCancelFlag) {
    		self.clearMessage();
    		if(item != null){
    			if(!isCancelFlag && item.eTrrbReceipts != undefined){
    				self.loading = true;
    				ETrrbService.get({
        				uri : 'check-etrrb-is-momo-with-payment',
        				eTrrbReceiptId : item.eTrrbReceipts[0].etrrbReceiptId
        			}, function(result) {
        				self.loading = false;
        				
        				var modalInstance = 
        					//show dialog
        					$uibModal.open({
        						animation : true,
        						templateUrl : GLOBAL_URL+ 'partial?uri=ga/etrrb/etrrb-cancel-request-dialog',
        						controller : 'EtrrbCancelRequestDialogController as etrrbCancelDialogCtr',
        						size : 'lg',
        						resolve : {
        							etrrbInfo: function(){
        								return item;
        							},
        							isCancelFlag: function() {
        								return isCancelFlag;
        							}
        						}
        				});
        				
            			modalInstance.result.then(
    							function(result) {
    								findReceiptCancelByBookletNum();
    							},
    							function(error) {
    								
    							}
    					);
            			
        			}, function(error) {
        				self.loading = false;
        			});
    			} else {
    				var modalInstance = 
					//show dialog
					$uibModal.open({
						animation : true,
						templateUrl : GLOBAL_URL+ 'partial?uri=ga/etrrb/etrrb-cancel-request-dialog',
						controller : 'EtrrbCancelRequestDialogController as etrrbCancelDialogCtr',
						size : 'lg',
						resolve : {
							etrrbInfo: function(){
								return item;
							},
							isCancelFlag: function() {
								return isCancelFlag;
							}
						}
				});
    			modalInstance.result.then(
						function(result) {
							findReceiptCancelByBookletNum();
						},
						function(error) {
							
						});
    			}
    		}
    	}
		
		etrrbCtr.datePickerOpenStatus = {};
		etrrbCtr.datePickerOpenStatus.fromDate = false;
		etrrbCtr.datePickerOpenStatus.toDate = false;
		etrrbCtr.openCalendar = openCalendar;
		function openCalendar(date) {
			etrrbCtr.datePickerOpenStatus[date] = true;
		}
		etrrbCtr.dateOptions = {
		// maxDate : new Date()
		};
		etrrbCtr.openFromDate = function() {
			etrrbCtr.popupFromDate.opened = true;
		};

		self.formats = [ 'dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd/MM/yyyy',
				'shortDate' ];
		self.format = $scope.formats[2];
		self.altInputFormats = [ 'M!/d!/yyyy' ];
		etrrbCtr.popupFromDate = {
			opened : false
		};

		etrrbCtr.searchAgent = function() {
			self.loading = true;
			if (etrrbCtr.agentCode != undefined && etrrbCtr.agentCode != null
					&& etrrbCtr.agentCode != '') {
				ETrrbService.get({
					uri : 'get-agent',
					agentCode : etrrbCtr.agentCode
				}, function(result) {
					etrrbCtr.agentName = result.agentName;
					self.loading = false;
				}, function(error) {
					self.loading = false;
				});
			}
		};

		etrrbCtr.fillAgent = function() {
			var code = etrrbCtr.agentCode;
			if (code == undefined || code == null || code == '') {
				etrrbCtr.agentName = '';
				return;
			}
			if (code != undefined || code != '') {
				var numCode = Number(code);
				if (numCode < 10000000)
					numCode += 60000000;
				etrrbCtr.agentCode = numCode.toString();
			}
		};

		etrrbCtr.searchPolicy = function() {
			self.loading = true;
			if (etrrbCtr.proposalPolicyNum != undefined && etrrbCtr.proposalPolicyNum != null
					&& etrrbCtr.proposalPolicyNum != '') {
				
				/*ETrrbService.get({
					uri : 'get-po-name',
					proposalPolicyNum : etrrbCtr.proposalPolicyNum
				}, function(result) {
					etrrbCtr.cusName = result.ownerName;
					self.loading = false;
				}, function(error) {
					self.loading = false;
				});*/
				var param = {};
				param['page'] = 1;
				param['size'] = 1;
				param['uri'] = 'get-etrrb-by-booklet-num';
				if (etrrbCtr.proposalPolicyNum) {
					param['proposalPolicyNum'] = etrrbCtr.proposalPolicyNum;
				}
				ETrrbService.get(param, function(result) {
					if (result != null 	&& (result.totalElements != undefined || result.totalElements > 0)) {

						if(result.content[0].eTrrbTransaction != undefined && result.content[0].eTrrbTransaction != null)
						{
							etrrbCtr.cusName = result.content[0].eTrrbTransaction.poName;
						}

						if(result.content[0].zautoter == "Y")
						{
							self.addAlert("Sản phẩm bổ trợ PRU-Hành Trang Vui Khỏe trong Hợp đồng bảo hiểm của Quý khách sẽ không được gia hạn \n" +
								"\n" +
								"Xem thông tin chi tiết tại ",
								'danger'
								, "https://khachhang.prudential.com.vn/customer-portal/web/eletterweb/index.html#/"
								, "E Letter (prudential.com.vn)");
						}
					}
					
					self.loading = false;
				}, function(error) {
					self.loading = false;
				});
					self.loading = false;
			}
		};
	}

})();
